import { render, staticRenderFns } from "./UpdateDocGnc.vue?vue&type=template&id=776c3f6b&scoped=true"
import script from "./UpdateDocGnc.vue?vue&type=script&lang=js"
export * from "./UpdateDocGnc.vue?vue&type=script&lang=js"
import style0 from "./UpdateDocGnc.vue?vue&type=style&index=0&id=776c3f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776c3f6b",
  null
  
)

export default component.exports